import React, { useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";

import SetupGuideHeader from "../components/SetupGuideHeader";

import { useDispatch } from "react-redux";

import { CmsConstructor } from "../helpers/cmsConstructor";
import { useCmsHook } from "../helpers/cmsHook";
import CmsEditAndSave from "../helpers/CmsEditAndSave";

const SetupGuide = () => {
  const { cmsInstance, setCmsInstance } = useCmsHook();
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.pathname === "/setupGuide") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="setup-guide-page">
      <SetupGuideHeader />
      {!cmsInstance ? (
        <div
          className="d-flex flex-row justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="d-flex flex-row justify-content-center align-items-center">
              <Spinner animation="border" variant="success" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="mt-4 d-flex justify-content-center">
            <CmsEditAndSave />
          </div>
          <Container className="p-5">
            <div className="setup-guide-main-content d-flex flex-column align-items-center justify-content-center">
              <div className="col-md-11 col-12">
                <div className="setup-guide-content-container">
                  {cmsInstance &&
                    cmsInstance.showRichText("cmsContent.setupGuide")}
                  <div>
                    <p className="setup-guide-footer-text">
                      Updated 27/ 03/ 2023
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </>
      )}
    </div>
  );
};

export default SetupGuide;
